import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { avoid } from './shared/avoid'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { audience } from './shared/audience'
import { callToAction } from './shared/callToAction'
import { promotion } from './shared/promotion'
import { productName } from './shared/productName'
import { Sms } from 'almanac-ui/icons/blaze/32'
import { count } from './shared/count'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { language } from './shared/language'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.SMSMessages,
  icon: Sms,
  steps: ['Context', 'Generate SMS Messages'],
  title: TextChannels[ChannelType.SMSMessages].name,
  submitLabel: 'Generate SMS Messages',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183791/Home%20Card%20Previews/xqgj3guqtyk0vkjyilt7.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your SMS messages?', generationType: meta.type }),
  product_name: productName.meta({
    label: 'Your product or company name',
    mobilePlaceholder: 'The name of your product/company',
    placeholder: 'What’s the name of the product/company you are promoting',
    inCollapsibleSection: true,
  }),
  audience: audience.required().meta({ label: 'Who is the target audience?' }),
  count: count
    .default(3)
    .min(1)
    .max(7)
    .meta({ label: 'How many messages do you want in this SMS sequence?', inCollapsibleSection: true }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  include_images: includeImages,
  tone,
  language,
  promotion: promotion.meta({ collapsible: true }),
  callToAction: callToAction.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
}

export const SMSMessagesSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const SMSMessagesMultiStepSchema: MultiStepSchema<ChannelType.SMSMessages> = {
  steps: [
    SMSMessagesSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.SMSMessages,
    channel: ChannelType.SMSMessages,
  },
}
